import { render, staticRenderFns } from "./EnrolmentRequestorView.vue?vue&type=template&id=71713e45&scoped=true&"
import script from "./EnrolmentRequestorView.vue?vue&type=script&lang=js&"
export * from "./EnrolmentRequestorView.vue?vue&type=script&lang=js&"
import style0 from "./EnrolmentRequestorView.vue?vue&type=style&index=0&id=71713e45&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71713e45",
  null
  
)

export default component.exports